import React from 'react';
import ConfirmWithCommentDialog, { ConfirmWithCommentPayload } from './ConfirmWithCommentDialog';
import { HelpBox } from '../help-boxes';

interface EPDDetails {
  title?: string;
  fullIdentificationNumber?: string;
}

type Props = {
  epd: EPDDetails | null | undefined;
  isOpened: boolean;
  onClose(payload: ConfirmWithCommentPayload | null): void;
};

const DeclineVerificationDialog: React.FC<Props> = ({ epd, isOpened, onClose }) => {
  return (
    <ConfirmWithCommentDialog
      header="Decline EPD verification"
      help={
        <HelpBox>
          <span>
            Please describe the reason for declining the verification of the EPD document &nbsp;
            <b>
              {epd?.fullIdentificationNumber} {epd?.title}
            </b>
          </span>
          The EPD Owner will be informed via e-mail about the declined verification.
        </HelpBox>
      }
      inputLabelText="Decline verification description"
      primaryButtonText="Decline"
      isOpened={isOpened}
      onClose={onClose}
      isCommentRequired
      closable={false}
    />
  );
};

export default DeclineVerificationDialog;
